import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
interface CountdownTimerProps {
  className?: string;
  variant?: 'banner' | 'inline' | 'minimal';
}
export function CountdownTimer({
  className = '',
  variant = 'inline'
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 15,
    seconds: 0
  });
  useEffect(() => {
    // Initialize with a fixed end time relative to now to simulate urgency
    // In a real app, this would be a fixed date or user-specific deadline
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            ...prev,
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        } else {
          // Reset when reaches zero to keep urgency alive (evergreen timer)
          return {
            hours: 0,
            minutes: 15,
            seconds: 0
          };
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  if (variant === 'banner') {
    return <div className={`flex items-center justify-center gap-2 text-white font-bold ${className}`} data-id="element-11">
        <div className="flex items-center gap-1.5" data-id="element-12">
          <Clock className="w-3.5 h-3.5" data-id="element-13" />
          <span className="uppercase tracking-wider text-xs" data-id="element-14">
            Oferta termina en:
          </span>
        </div>
        <div className="flex items-center gap-1 text-sm font-mono bg-black/20 px-2 py-0.5 rounded backdrop-blur-sm" data-id="element-15">
          <div className="flex flex-col items-center" data-id="element-16">
            <span data-id="element-17">{formatNumber(timeLeft.hours)}</span>
          </div>
          <span className="text-[10px]" data-id="element-18">:</span>
          <div className="flex flex-col items-center" data-id="element-19">
            <span data-id="element-20">{formatNumber(timeLeft.minutes)}</span>
          </div>
          <span className="text-[10px]" data-id="element-21">:</span>
          <div className="flex flex-col items-center text-yellow-300" data-id="element-22">
            <span data-id="element-23">{formatNumber(timeLeft.seconds)}</span>
          </div>
        </div>
      </div>;
  }
  if (variant === 'minimal') {
    return <div className={`flex items-center gap-1 font-mono text-sm ${className}`} data-id="element-24">
        <span className="bg-gray-800 text-white px-1.5 py-0.5 rounded" data-id="element-25">
          {formatNumber(timeLeft.hours)}
        </span>
        :
        <span className="bg-gray-800 text-white px-1.5 py-0.5 rounded" data-id="element-26">
          {formatNumber(timeLeft.minutes)}
        </span>
        :
        <span className="bg-red-600 text-white px-1.5 py-0.5 rounded animate-pulse" data-id="element-27">
          {formatNumber(timeLeft.seconds)}
        </span>
      </div>;
  }
  return <div className={`flex items-center gap-2 text-red-600 font-bold ${className}`} data-id="element-28">
      <Clock className="w-5 h-5" data-id="element-29" />
      <span className="uppercase text-sm" data-id="element-30">Termina en:</span>
      <div className="flex items-center gap-1 font-mono text-lg" data-id="element-31">
        <span className="bg-red-100 px-2 py-1 rounded" data-id="element-32">
          {formatNumber(timeLeft.hours)}h
        </span>
        <span className="bg-red-100 px-2 py-1 rounded" data-id="element-33">
          {formatNumber(timeLeft.minutes)}m
        </span>
        <span className="bg-red-600 text-white px-2 py-1 rounded animate-pulse" data-id="element-34">
          {formatNumber(timeLeft.seconds)}s
        </span>
      </div>
    </div>;
}